import { ArrowUpDown } from "lucide-react";
import {
  LamaTopMoversParamsSchema,
  defaultLamaTopMoversParams,
  type LamaTopMoversOutput,
  type LamaTopMoversParams,
} from "@playbookai/widget-schemas";
import { lamaParamsEditor } from "../lama-report-params/Editor.js";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaTopMoversWidget } from "./Component.js";

/**
 * LAMA Top Movers — dashboard-only report section (plan §13.3).
 * `TView` is the `lama/top-movers@1` dataset output.
 */
export const lamaTopMoversDef: SqlWidgetDef<
  LamaTopMoversParams,
  LamaTopMoversOutput
> = {
  kind: "lamaTopMovers",
  label: "Top Movers",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 280 },
  defaultParams: defaultLamaTopMoversParams,
  Component: LamaTopMoversWidget,
  storage: "sql",
  schema: LamaTopMoversParamsSchema,
  accent: "cyan",
  icon: ArrowUpDown,
  subtitle: "Most improved and slipping areas",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 6, width: 960, height: 280 },
  dashboard: {
    icon: ArrowUpDown,
    defaultWidth: "full",
    category: "Operations",
    supportsTitleOverride: true,
    EditorForm: lamaParamsEditor("lamaTopMovers"),
  },
};

registerWidget(lamaTopMoversDef);
